import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { GuestCard } from "../components/GuestCard";

export default function Guests() {
    const [guests, setGuests] = useState([]);

    useEffect(() => {
        api.get("/guests").then((r) => setGuests(r.data || []));
    }, []);

    return (
        <div data-testid="guests-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
            <div className="grid md:grid-cols-12 gap-10 mb-16 items-end">
                <div className="md:col-span-7">
                    <div className="eyebrow text-[#B8860B] mb-6">Collaborations</div>
                    <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1]">
                        Our Guests
                    </h1>
                </div>
                <div className="md:col-span-5">
                    <p className="text-lg text-black/65 font-light leading-relaxed">
                        Storytellers, helpers, healers — every guest brought something we're still thinking about.
                    </p>
                    <Link to="/apply" data-testid="guests-apply-link" className="inline-block mt-6 eyebrow hover:text-[#B8860B]">
                        Be Our Next Guest →
                    </Link>
                </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                {guests.map((g) => <GuestCard key={g.id} guest={g} />)}
            </div>
        </div>
    );
}
